<template>
  <div class="topUpBox">
    <Nav />
		<div class="topUp">
			<Banner :location="3" />
			<div class="_cont">
				<div class="_List" v-if="payActive !== 3">
					<div 
					v-for="(item, index) in amountList" 
					:key="index"
					:class="'_li '+ [topupActive == index ? '_active' : ''] " 
					@click.stop="activeTopup(index,item.price_alias)"
					>
						<p class="_top">{{item.gold_alias}}<span class="_yuan">¥</span></p>
						<p class="_bot">{{item.price_alias}}元</p>

					</div>
					<div 
						:class="'_li '+ [topupActive == amountList.length+1 ? '_active' : ''] " 
						@click.stop="activeTopup(amountList.length+1)"
					>
						<p class="_tops">自定义金额</p>
						<p class="_bots">
							<el-input :disabled="topupActive !== amountList.length+1" class="_1input" type="number" v-model="payMoneys" placeholder="1-10000" @input="handleCustomAmountInput" min="1" max="10000"></el-input>
							<span class="_2span">元</span>
						</p>
					</div>
				</div>
				<div class="_payType">
					<p class="_label">支付类型</p>
					<div class="_payList">
						<li 
						v-for="(item,index) in payList"
						:key="index"
						:class="'_li ' + [payActive == index ? '_active' : '']"
					
						@click.stop="activePay(item.id)"
						>
							<img :src="item.img" alt="">
							<p>{{item.name}}</p>
						</li>
					</div>
				</div>
				<div class="_total" v-if="payActive !== 3">
					<p class="_label">账单合计</p>
					<p class="_amount">￥{{payMoney ? payMoney : '0'}}</p>
				</div>
				<div class="_CDK" v-else>
					<p class="_label">输入卡密</p>
					<textarea v-model="cdkeyText" class="_texttarea" name="" id="" cols="30" rows="10"></textarea>
				</div>
				<div class="_cdk_tips">
					tips:需要微信支付或对公转账等情况，可联系客服进行充值
				</div>
				<div class="_paybutton">
					<p class="_button" @click.stop="_pay()"  style="cursor:pointer;">确认支付</p>
				</div>
				<div class="_payprompt">
					<p class="_label">友情提示</p>
					<p class="_p">1. 注册/购买后点击页面右上角“进入后台”，在【个人中心】页面可查看应用信息，生成提取连接。</p>
					<p class="_p">2. 如您需要更大的单次提取量，可联系在线客服私人定制。</p>
				</div>
			</div>
		</div>
    <Foot />
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import { WOW } from 'wowjs' 
import Foot from '@/components/Foot.vue'
import Banner from '@/components/Banner.vue'
import { request } from "../css/request.js";
import { Apis } from "../css/Api.js";
export default {
  name: 'topUp',
  components: {
    Nav,
    Foot,
    Banner
  },
  data(){
    return {
			topupActive:null,
			payList:[
				{img:require('../assets/zfb.png'),name:'支付宝', id: 1},
				// {img:require('../assets/weixin.png'),name:'微信', id: 2},
				// {img:require('../assets/km2.png'),name:'卡密', id: 3},
			],
			payActive:'0',
			amountList:[
				{ price_alias: 30, gold_alias: 30 },
				{ price_alias: 168, gold_alias: 168 },
				{ price_alias: 328, gold_alias: 328 },
				{ price_alias: 648, gold_alias: 648 },
			],
			payMoney:'',
			payMoneys:'',
			cdkeyText:''
    }
	},
	watch:{
		'payMoneys':{
			handler(value) {
				if(this.topupActive == this.amountList.length+1){
					this.payMoney = value
				}
			},
      immediate: true,
      deep: true
		}
	},
	created(){
		// 使用固定金额列表，无需请求接口
	},
  methods:{
		// 自定义金额输入处理：只允许输入整数，不能以 0 开头，最大 10000
		handleCustomAmountInput(value){
			// 移除小数点和非数字字符
			let numStr = value.replace(/[^0-9]/g, '');
			// 去除前导 0（保留单个 0）
			if (numStr.length > 1) {
				numStr = numStr.replace(/^0+/, '');
			}
			// 限制最大值为 10000
			if (numStr && parseInt(numStr) > 10000) {
				numStr = '10000';
			}
			this.payMoneys = numStr;
		},
		activeTopup(index,money){
			this.topupActive = index
			if(this.topupActive == this.amountList.length+1){
				// 自定义金额，使用输入框的值（整数）
				this.payMoney = this.payMoneys ? parseInt(this.payMoneys) : '';
			}else{
				this.payMoney = money;
			}
		},
		activePay(index){
			this.payActive = index
			console.log(this.payActive)
		},
		_pay(){
			// 检查登录状态
			const access_token = localStorage.getItem('access_token')
			if(!access_token){
				// 弹出登录框
				this.$store.commit('setLoginType', true)
				this.$store.commit('setRegisterType', '1')
				return
			}
			
			if(this.payActive == '0'){
				this.zfb_pay()
			}else if(this.payActive == '1'){
				this.cdkey_pay()
			}
		},
		clearBdVidNative() {
			const url = new URL(window.location.href)
			url.searchParams.delete('bd_vid')
			window.history.replaceState({}, '', url.href)
		},
		zfb_pay(){
			if(this.payMoney == ''){
				this.$message.error('请选择充值金额');
				return;
			}
			// 验证金额为整数
			if(!Number.isInteger(Number(this.payMoney))){
				this.$message.error('充值金额必须为整数');
				return;
			}
			// 验证金额范围：1-10000
			if(this.payMoney < 1){
				this.$message.error('充值金额不能小于 1 元');
				return;
			}
			if(this.payMoney > 10000){
				this.$message.error('充值金额不能大于 10000 元');
				return;
			}
			// 金额单位转换：元 -> 厘
			const amountInLi = this.payMoney * 1000;
			let access_token = localStorage.getItem('access_token')
			let data = {
				amount: amountInLi.toString(), // 单位：厘，字符串格式
				access_token: access_token
			}
			const bdData = localStorage.getItem('bdData') ? JSON.parse(localStorage.getItem('bdData')) : null
			if (bdData) {
				data.bd_vid = bdData.bd_vid
				data.bd_url = bdData.bd_url
			}
			request({
				method: 'get',
				url: Apis.deposit,
				params: data
			}).then(res => {
				// code: -10 表示需要实名认证
				if (res.code === -10) {
					this.$confirm(res.msg || '需要实名认证', '提示', {
						confirmButtonText: '前往实名',
						cancelButtonText: '取消',
						type: 'warning',
						closeOnClickModal: false
					}).then(() => {
						// 前往实名：跳转到个人中心实名认证页
						this.$store.commit('setMineActiveLi', 1)
						this.$router.push('/mine')
					}).catch(() => {
						// 取消：关闭弹窗
					});
					return;
				}
				
				if(res.code == 0){
					if (bdData) {
						localStorage.removeItem('bdData')
						this.clearBdVidNative()
					}
					// 如果返回 payUrl，直接新窗口打开
					if(res.data.payUrl){
						window.open(res.data.payUrl, '_blank');
					}else{
						this.$message.error('支付失败');
					}
				}else{
					this.$message.error(res.msg);
				}
			});
		},
		cdkey_pay(){
			if(this.cdkeyText == ''){
				this.$message.error('卡密不得为空');
				return;
			}
			let access_token = localStorage.getItem('access_token')
			let data = {
				cdkey:this.cdkeyText,
				access_token:access_token,
			}
			request({
				method: 'post', 
				url: Apis.cdkey,
				params:data
			}).then(res => {
				if(res.code == 0){

					this.$alert(res.msg, '充值结果', {
						confirmButtonText: '确定',
						showClose:false,
						dangerouslyUseHTMLString:true,
						callback: action => {
						
						}
					});
				}else{
					this.$message.error(res.msg);
				}
			});
		}
  }
}
</script>

<style lang="less" scoped>
.topUpBox{
  width: 100%;
	min-height: 800px;
	.topUp{
		.banner{
			width: 100%;
			height: 260px;
			// background: url('../assets/banner_2.png')no-repeat;
			background-size: 100% 100%;
			h1,h3{
				width: 100%;
				color: #fff;
				text-align: center;  
				text-shadow: -2px 2px 0px #2a4fe4;
			}
			h1{
				font-size: 36px;
				font-weight: bold;
				padding-top: 85px;
			}
			h3{
				font-size: 16px;
				padding-top: 10px;
			}
		}
		._cont{
			width: 1200px;
			margin: 0 auto;
			// background: palegreen;
			._List{
				width: 100%;
				display: flex;
				justify-content: space-around;
				margin-top: 65px;
				._li{
					width: 224px;
					height: 220px;
					border-radius: 20px;
					overflow: hidden;
					background: #fff;
					box-shadow: 0px 11px 32px 0px rgba(217, 229, 241, 0.31);
					position: relative;
					cursor:pointer;
					._top{
						width: 100%;
						height: calc(100% - 78px);
						font-size: 48px;
						color: #E21A81;
						font-weight: bold;
						line-height: 150px;
						position: relative;
						._cc{
							font-size: 18px;
							color: #222121;
						}
						._decoration{
							text-decoration:line-through; 
							color:#ccc;
							font-size: 16px;
							position: absolute;
							top: 40px;
							left: 50%;
							transform: translateX(-50%);
						}
						._yuan{
							font-size: 28px;
							color: #E21A81;
							margin-left: 2px;
						}
					}
					._bot{
						width: 100%;
						height: 78px;
						background: #F0F6FD;
						font-size: 20px;
						color: #222121;
						font-weight: bold;
						line-height: 78px;
					}
					._tops{
						width: 100%;
						height: 65%;
						line-height: 160px;
						font-size: 24px;
					}
					._bots{
						width: 100%;
						height: 35%;
						display: flex;
						justify-content: center;
						align-items: center;
						line-height: 40px;
						padding: 10px;
							background: #F0F6FD;
						font-size: 20px;
						color: #222121;
						font-weight: bold;
						._1input{
							width: 120px;
						}
						._2span{
							padding-left: 5px;
						}
					}
				}
				._active{
					border: 2px solid #1F8EFF;
					._top{
						line-height: 146px;
						height: calc(100% - 76px);
					}
				}
				._active::after{
					content: '';
					display: inline-block;
					width: 55px;
					height: 55px;
					background: url('../assets/priceb.png')no-repeat;
					background-size: 100%;
					position: absolute;
					right: 0;
					top: -1px;
				}
			}
			._payType{
				width: 100%;
				margin-top: 68px;
				display: flex;
				align-items: center;
				font-size: 20px;
				._label{
					width: 100px;
					position: relative;
					line-height: 30px;
					font-weight: bold;
				}
				._label::after{
					content: '';
					display: inline-block;
					width: 4px;
					height: 23px;
					background: #51B3FF;
					position: absolute;
					top: 5px;
					left: 0px;
				}
				._payList{
					width: calc(100% - 100px);
					display: flex;
					line-height: 40px;
					._li{
						min-width: 140px;
						height: 40px;
						border: 1px solid #DEDEDE;
						display: flex;
						justify-content: center;
						align-items: center;
						position: relative;
						margin-right: 20px;
						cursor:pointer;
						img{
							width: 27px;
							// height: 23px;
						}
						p{
							margin-left: 5px;
						}
					}
					._active{
						border: 1px solid #1F8EFF;
					}
					._active::after{
						content: '';
						display: inline-block;
						width: 22px;
						height: 22px;
						background: url('../assets/priceb.png')no-repeat;
						background-size: 100%;
						position: absolute;
						right: 0;
						top: -1px;	
					}
				}
			}
			._total{
				width: 100%;
				margin-top: 40px;
				display: flex;
				// align-items: center;
				font-size: 20px;
				._label{
					width: 100px;
					position: relative;
					line-height: 30px;
					font-weight: bold;
				}
				._label::after{
					content: '';
					display: inline-block;
					width: 4px;
					height: 23px;
					background: #51B3FF;
					position: absolute;
					top: 5px;
					left: 0px;
				}
				._amount{
					font-size: 22px;
					color: #E21A81;
					font-weight: bold;
					// line-height: 20px;
				}
			}
			._cdk_tips{
				width: 100%;
				text-align: left;
				font-size: 13px;
				margin-top: 20px;
				margin-left: 100px;

			}
			._CDK{
				width: 100%;
				margin-top: 40px;
				display: flex;
				// align-items: center;
				font-size: 20px;
				._label{
					width: 100px;
					position: relative;
					line-height: 30px;
					font-weight: bold;
				}
				._label::after{
					content: '';
					display: inline-block;
					width: 4px;
					height: 23px;
					background: #51B3FF;
					position: absolute;
					top: 5px;
					left: 0px;
				}
				._texttarea{
					width: 500px;
					resize: none;
					border: 1px solid #ddd;
					padding: 5px;
					outline: none;
				}
			}
			._paybutton{
				width: 100%;
				margin-top: 30px;
				._button{
					width: 253px;
					height: 55px;
					border-radius: 100px;
					background: #1F8EFF;
					color: #fff;
					line-height: 55px;
					margin: 0 auto;
					font-size: 22px;
					// font-weight: bold;
				}
			}
			._payprompt{
				width: 100%;
				min-height: 185px;
				margin-top: 47px;
				margin-bottom: 48px;
				background: #F0F6FD;
				padding: 30px;
				._label{
					width: 100px;
					position: relative;
					line-height: 30px;
					font-weight: bold;
					font-size: 20px;
				}
				._label::after{
					content: '';
					display: inline-block;
					width: 4px;
					height: 23px;
					background: #51B3FF;
					position: absolute;
					top: 5px;
					left: 0px;
				}
				._p{
					text-align: left;
					margin-top: 20px;
					font-size: 18px;
				}
			}
		}
	}
}
 @media screen and (max-width: 1200px) {
    .topUpBox{
    }
  }
</style>
<style scoped>
._form >>> .el-radio{
	margin-right: 0px;
}
._form >>> .el-input__inner{
	width: 80%;
}
._form >>> .el-button{
	margin-left: 36%;
}
</style>